<template>
	<div class="page-login">
		<div class="container">
			<!-- Login Logo -->
			<div class="login-logo text-center">
				<picture>
					<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				</picture>
			</div>
			<!-- Login Box -->
			<div class="login-box card magic-link-box">
				<div class="login-box-content">
					<form @submit.prevent="">
						<div class="mb-3">
							<h2 class="font-weight-normal">{{ $t('Resend Confirmation Email') }}</h2>
						</div>
						<div class="text-small mb-3">
							{{ $t('Please enter your email, we will email you the instruction to activation your Account') }}
						</div>
						<!-- Email -->
						<div class="form-group">
							<div class="form-group">
								<label>{{ $t('Email') }}</label>
								<input type="email" name="email" class="form-control" v-model="email" required>
							</div>
						</div>
						<!-- Submit -->
						<div class="d-flex justify-content-between">
							<div class="login-extra d-flex align-items-center">
								<router-link class="login-action mr-2" to="/login">{{ $t('Back To Login') }}</router-link>
							</div>
							<div>
								<button
									@click="resendConfirmation"
									type="submit"
									:disabled="!email"
									class="btn btn-submit btn-primary"
									:class="{ 'is-loading': isResetting }">
									{{ $t('Resend') }}
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<footer
			class="footer footer-main">
			<div class="d-flex justify-content-between">
				<div>
					<div class="footer-brand text-grey"><span>{{ $t('Ver.') }} {{ appVersion }}</span></div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorMessage } from '../lib/helper';
import authApi from '../api/auth';
import {
	appVersion,
} from '@/lib/statics';

export default {
	name: 'ChangePassword',
	components: {
	},
	data() {
		return {
			email: '',
			error: false,
			errorMessage: '',
			languageLabel: {
				en: 'English',
				no: 'Norsk',
			},
			isResetting: false,
		};
	},
	methods: {
		...mapActions({
			setLocale: 'setLocale',
		}),
		resendConfirmation() {
			this.isResetting = true;
			const params = {
				key: this.email,
				verification_method: 'email',
				lang: 'en',
			};
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Resend Confirmation',
					text: message,
				});
				this.$router.push('/login').catch(() => {});
				this.isResetting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Resend Confirmation',
					text: message,
					duration: 7000,
				});
				this.isResetting = false;
			};
			authApi.resendConfirmation(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			locale: 'locale',
			isLoggingIn: 'isLoggingIn',
			loginError: 'loginError',
		}),
		token() {
			const { token } = this.$route.query;
			return token;
		},
		lang() {
			const lang = this.$route.query.lang || this.locale;
			return lang;
		},
		appVersion() {
			return appVersion;
		},
	},
	watch: {
	},
};
</script>
